import React from 'react';
import { block } from '../utils/cn';
import { withEventBrokerDomHandlers } from '../utils/withEventBrokerDomHandlers';
import './Link.css';
const b = block('link');
const PureLink = React.forwardRef(function Link({ view = 'normal', href, target, rel, title, children, extraProps, onClick, onFocus, onBlur, id, style, className, qa, }, ref) {
    const commonProps = {
        title,
        children,
        onClick,
        onFocus,
        onBlur,
        id,
        style,
        className: b({ view }, className),
        'data-qa': qa,
    };
    if (typeof href === 'string') {
        const relProp = target === '_blank' && !rel ? 'noopener noreferrer' : rel;
        return (React.createElement("a", Object.assign({}, extraProps, commonProps, { ref: ref, href: href, target: target, rel: relProp })));
    }
    else {
        return (React.createElement("span", Object.assign({}, extraProps, commonProps, { ref: ref, tabIndex: 0 })));
    }
});
PureLink.displayName = 'Link';
export const Link = withEventBrokerDomHandlers(PureLink, ['onClick'], { componentId: 'Link' });
